import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// 1. استيراد صفحة الهبوط الجديدة
import LandingPage from './pages/LandingPage'; 
import ProfilePage from './pages/ProfilePage';
import LoginPage from './pages/LoginPage';
import UserDashboard from './pages/UserDashboard';
import AdminLayout, { AdminUserList, AdminEditUser } from './pages/AdminDashboard';

function App() {
  return (
    <Router>
      <Routes>
        {/* --- المسارات العامة --- */}
        
        {/* 2. تغيير المسار الرئيسي "/" */}
        <Route path="/" element={<LandingPage />} /> {/* <-- كان يحوّل إلى /login */}
        
        <Route path="/login" element={<LoginPage />} />
        <Route path="/:username" element={<ProfilePage />} />

        {/* --- مسارات المستخدم المحمية --- */}
        <Route path="/dashboard" element={<UserDashboard />} />

        {/* --- مسارات الأدمن المحمية --- */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="users" />} /> 
          <Route path="users" element={<AdminUserList />} />
          <Route path="users/edit/:userId" element={<AdminEditUser />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;